import styled from 'styled-components';

type TWrapperProps = {
  $compact?: boolean;
};

export const Wrapper = styled.div<TWrapperProps>`
  display: flex;
  flex-direction: column;
  padding: ${(props) => (props.$compact ? 0 : '15px')};
  cursor: default;
  ${(props) =>
    props.$compact
      ? ''
      : `
    min-height: 300px;
    min-width: 0;
    width: 300px;
    max-width: calc(100vw - 32px);
  `}
`;
